module.exports = __webpack_public_path__ + "img/software-certificate.d38322e4.jpg";